import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatTabNavPanel } from '@angular/material/tabs';
import { NavigationEnd, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements OnInit, OnDestroy {
  @Input() name: string = '';
  @Input() tabPanel!: MatTabNavPanel;

  navLinks: { label: Observable<string>; link: string; index: number }[] = [];
  routeEventSub!: Subscription;
  activeLinkIndex = -1;

  constructor(private router: Router, private translate: TranslateService) {}

  ngOnInit(): void {
    this.navLinks = [
      {
        label: this.translate.get(
          `${this.name.toLocaleUpperCase()}.TABS.FINALISED_${this.name.toLocaleUpperCase()}`
        ),
        link: `/selling/sortiment/product-sortiment/products-start/${this.name}`,
        index: 0,
      },
      {
        label: this.translate.get(
          `${this.name.toLocaleUpperCase()}.TABS.PENDING_${this.name.toLocaleUpperCase()}`
        ),
        link: `/selling/sortiment/product-sortiment/products-start/${this.name}/pending`,
        index: 1,
      },
      {
        label: this.translate.get(
          `${this.name.toLocaleUpperCase()}.TABS.REJECTED_${this.name.toLocaleUpperCase()}`
        ),
        link: `/selling/sortiment/product-sortiment/products-start/${this.name}/rejected`,
        index: 2,
      },
    ];

    this.navigate(this.router.url);
    this.routeEventSub = this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.navigate(e.urlAfterRedirects);
      }
    });
  }

  navigate(url: string): void {
    if (
      url.startsWith(
        `/selling/sortiment/product-sortiment/products-start/${this.name}/rejected`
      )
    ) {
      this.activeLinkIndex = 2;
    } else if (
      url.startsWith(
        `/selling/sortiment/product-sortiment/products-start/${this.name}/pending`
      )
    ) {
      this.activeLinkIndex = 1;
    } else {
      this.activeLinkIndex = 0;
    }
  }

  ngOnDestroy(): void {
    if (this.routeEventSub) {
      this.routeEventSub.unsubscribe();
    }
  }
}
